"use client";

import { useQuery } from "@tanstack/react-query";

import { Get } from "@/shared/libs/axios/request";
import { usePaginatedList } from "@/shared/libs/query";
import type {
  ItemImageResponse,
  ItemResponse,
  ListItemsQuery,
} from "@stocks/shared";

export const itemKeys = {
  all: ["items"] as const,
  detail: (id: string) => ["items", "detail", id] as const,
  images: (id: string) => ["items", "images", id] as const,
};

export const useItem = (id: string) =>
  useQuery({
    queryKey: itemKeys.detail(id),
    enabled: id !== "",
    queryFn: async () => (await Get<ItemResponse, never>(`/v1/items/${id}`)).data.data,
  });

export const useItemImages = (itemId: string) =>
  useQuery({
    queryKey: itemKeys.images(itemId),
    queryFn: async () =>
      (
        await Get<ItemImageResponse[], { itemId: string }>("/v1/file/images", {
          itemId,
        })
      ).data.data ?? [],
  });

/** 자재 선택용 품목 목록 (사용 중인 품목만, 검색어 지원) */
export const useItemOptions = (search: string) =>
  usePaginatedList<ItemResponse, ListItemsQuery>("items", "/v1/items", {
    pageSize: 50,
    sort: "name",
    order: "asc",
    isActive: true,
    search: search || undefined,
  });
